import * as React from 'react';
import { useHistory, useLocation } from 'react-router';

import { useAppSelector } from 'vms/app/hooks';
import { useCurrentUser } from 'vms/features/accounts/queries';
import { selectVehicleInWork } from 'vms/features/vehicles/selectors';

import { canStopWorkForOther } from './rules';

function useLockedInWork() {
  const currentUser = useCurrentUser();
  const inWork = useAppSelector(selectVehicleInWork);
  // A user missing from the directory gets no permissions, so stays locked.
  return inWork && !canStopWorkForOther(currentUser) ? inWork : null;
}

export function redirectIfInWork<P extends object>(Wrapped: React.ComponentType<P>) {
  function Inner(props: P) {
    const inWork = useLockedInWork();
    const history = useHistory();
    const location = useLocation();
    React.useLayoutEffect(() => {
      if (inWork) {
        const url = `/vehicles/${inWork.vehicle}/`;
        if (location.pathname !== url) {
          history.replace(url);
        }
      }
    }, [history, location, inWork]);

    return <Wrapped {...props} />;
  }

  return Inner;
}

export function hideIfInWork<P extends object>(Wrapped: React.ComponentType<P>) {
  function Inner(props: P) {
    const inWork = useLockedInWork();
    return inWork ? null : <Wrapped {...props} />;
  }

  return Inner;
}
